import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import CfdiUnidadMedida from './CfdiUnidadMedida.js';
import ACCESS from '../../../ACCESS.js';

class CfdiUnidadesMedida extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'cfdi-unidad/filter', deleteUrl: 'cfdi-unidad/delete', deleteField: 'cfdi_nombre', modUrl: '/Catalogo/CfdiMedidaUnidad' },
      TableOp.Table('Unidades de Medida CFDI', [
        { label: 'Clave', id: 'cfdi_clave' },
        { label: 'Nombre', id: 'cfdi_nombre' },
        { label: 'Descripcion', id: 'cfdi_descripcion' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_UNIDADES_DE_MEDIDA_CFDI.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_UNIDADES_DE_MEDIDA_CFDI.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
           
          <CfdiUnidadMedida  onSave={() => {this.table()}}></CfdiUnidadMedida>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(CfdiUnidadesMedida)